import _styled15 from "../web_modules/styled-components.js";
import _styled14 from "../web_modules/styled-components.js";
import _styled13 from "../web_modules/styled-components.js";
import _styled12 from "../web_modules/styled-components.js";
import _styled11 from "../web_modules/styled-components.js";
import _styled10 from "../web_modules/styled-components.js";
import _styled9 from "../web_modules/styled-components.js";
import _styled8 from "../web_modules/styled-components.js";
import _styled7 from "../web_modules/styled-components.js";
import _styled6 from "../web_modules/styled-components.js";
import _styled5 from "../web_modules/styled-components.js";
import _styled4 from "../web_modules/styled-components.js";
import _styled3 from "../web_modules/styled-components.js";
import _styled2 from "../web_modules/styled-components.js";
import _styled from "../web_modules/styled-components.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../web_modules/react.js";
import Cookie from "../web_modules/js-cookie.js";
import * as Sentry from "../web_modules/@sentry/browser.js";
import { styles } from "./app.js";
import mobilePayIcon from "./assets/icons/mobilepay_grey.png";
import applePayIcon from "./assets/icons/apple_pay.png";
import dankortIcon from "./assets/icons/dankort.svg";
import visaIcon from "./assets/icons/visa.svg";
import mastercardIcon from "./assets/icons/mastercard.svg";
export const urlParams = new URLSearchParams(location.search);
export const isIframe = urlParams.has("iframe") || // TODO: Remove this when the "old" checkout is deprecated and we can change
// `get_absolute_url_iframe` in the core
// NOTE: /iframe/ is used in the QuickPay callback URLs
window.location.href.includes("/iframe");
export const isCheckoutModal = urlParams.has("isCheckoutModal");
export function getSearchParams() {
  return Object.fromEntries(new URLSearchParams(location.search));
}
export function useIframeTypes(whitelabel) {
  const isDetailIframe = React.useMemo(() => Boolean(isIframe && whitelabel.event_page_iframe_show_description), [whitelabel.event_page_iframe_show_description]);
  const isSimpleIframe = React.useMemo(() => isIframe && !isDetailIframe, [isDetailIframe]);
  return {
    isIframe,
    isSimpleIframe,
    isDetailIframe,
    isCheckoutModal
  };
}

var _StyledDiv = _styled("div").withConfig({
  displayName: "shared___StyledDiv",
  componentId: "sc-1kqbbso-0"
})({
  display: "flex",
  alignItems: "center"
});

var _StyledInput = _styled("input").withConfig({
  displayName: "shared___StyledInput",
  componentId: "sc-1kqbbso-1"
})(["", ""], p => p._css);

export function TappableNumberInput({
  name,
  defaultValue = 0,
  onChange
}) {
  const [value, setValue] = React.useState(defaultValue);
  const incrementValue = React.useCallback(function (increment) {
    setValue(v => v + increment);
  }, [setValue]);
  React.useEffect(function () {
    if (onChange) onChange(value);
  }, [value, onChange]);
  return /*#__PURE__*/React.createElement(_StyledDiv, null, /*#__PURE__*/React.createElement(IncrementButton, {
    onClick: () => {
      if (value > 0) incrementValue(-1);
    }
  }, "-"), /*#__PURE__*/React.createElement(_StyledInput, {
    type: "number",
    "data-testId": "tappable-input",
    name: name,
    value: value,
    onChange: function (e) {
      const newValue = parseInt(e.target.value);
      setValue(newValue);
    },
    _css: [styles.input, {
      maxWidth: 50
    }]
  }), /*#__PURE__*/React.createElement(IncrementButton, {
    onClick: () => incrementValue(1)
  }, "+"));
}

var _StyledButton = _styled("button").withConfig({
  displayName: "shared___StyledButton",
  componentId: "sc-1kqbbso-2"
})({
  borderRadius: "50%",
  backgroundColor: "white",
  minWidth: 25,
  maxWidth: 25,
  minHeight: 25,
  maxHeight: 25,
  boxShadow: "0px 0px 3px 3px #dcdcdc",
  border: "none",
  margin: "0 10px",
  position: "relative"
});

var _StyledSpan = _styled("span").withConfig({
  displayName: "shared___StyledSpan",
  componentId: "sc-1kqbbso-3"
})({
  fontWeight: "bold",
  fontSize: 16,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
});

function IncrementButton({
  children,
  onClick
}) {
  return /*#__PURE__*/React.createElement(_StyledButton, {
    type: "button",
    onClick: () => onClick()
  }, /*#__PURE__*/React.createElement(_StyledSpan, null, children));
}

var _StyledDiv2 = _styled("div").withConfig({
  displayName: "shared___StyledDiv2",
  componentId: "sc-1kqbbso-4"
})(p => ({
  color: "white",
  fontWeight: "bold",
  fontSize: p._css2,
  backgroundColor: "rgb(51,51,51)",
  borderRadius: 3,
  padding: 5
}));

export function DescriptiveTextLabel({
  children
}) {
  return /*#__PURE__*/React.createElement(_StyledDiv2, {
    _css2: window.innerWidth > 500 ? 14 : 12
  }, children);
}

var _StyledInput2 = _styled("input").withConfig({
  displayName: "shared___StyledInput2",
  componentId: "sc-1kqbbso-5"
})(p => ({
  position: "absolute",
  opacity: 0,
  width: 0,
  height: 0,
  "&:checked + span": {
    border: p._css3
  },
  "&:hover + span": {
    border: p._css4
  }
}));

var _StyledSpan2 = _styled("span").withConfig({
  displayName: "shared___StyledSpan2",
  componentId: "sc-1kqbbso-6"
})({
  "&:first-of-type": {
    marginRight: "0.5rem",
    display: "inline-block",
    position: "relative",
    height: "18px",
    width: "18px",
    borderRadius: "9px",
    border: "1.5px solid rgb(189, 189, 189)",
    verticalAlign: "middle"
  }
});

export const RadioSelect = ({
  inputs,
  name,
  onChange,
  style = {}
}) => /*#__PURE__*/React.createElement("div", {
  style: {
    padding: "5px 0",
    display: "flex",
    flexDirection: "column",
    ...style
  }
}, inputs.map(props => {
  return /*#__PURE__*/React.createElement("div", {
    key: props.id,
    style: {
      padding: "2.5px 0",
      cursor: props.disabled ? "unset" : "pointer"
    },
    onClick: event => {
      const element = event.target;
      ["INPUT", "LABEL", "DIV"].includes(element.tagName.toUpperCase()) && onChange && onChange(props.id);
    }
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: props.id.toString(),
    style: {
      cursor: props.disabled ? "unset" : "pointer",
      color: props.disabled ? "rgb(157, 157, 157)" : "rgb(51, 51, 51)",
      display: "flex",
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement(_StyledInput2, _extends({
    type: "radio",
    name: name
  }, props, {
    _css3: props.disabled ? "1.5px solid rgb(189, 189, 189)" : "1.5px solid rgb(50, 109, 233)",
    _css4: !props.checked && "1.5px solid rgb(157, 157, 157)"
  })), /*#__PURE__*/React.createElement(_StyledSpan2, null, /*#__PURE__*/React.createElement("svg", {
    width: "10px",
    height: "10px",
    viewBox: "0 0 100 100",
    style: {
      position: "absolute",
      top: "2.5px",
      left: "2.5px",
      fill: !props.checked ? "none" : props.disabled ? "rgb(189, 189, 189)" : "rgb(50, 109, 233)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "50"
  }))), props.label && /*#__PURE__*/React.createElement("span", null, props.label)));
}));
export const useScrollToError = errors => {
  React.useEffect(() => {
    // If there are API errors, scroll to the first field with error
    const firstError = document.querySelector(".errorMessage");
    const errorComponent = firstError && firstError.parentNode;

    if (errors && errorComponent) {
      errorComponent.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  }, [errors]);
};
const WAITING_ROOM_ACTIVE_COOKIE = "__waiting_room_active";
const WAITING_ROOM_HEARTBEAT_PATH = "/_waiting-room/heartbeat";
const WAITING_ROOM_HEARTBEAT_MIN_MS = 10000;
const WAITING_ROOM_HEARTBEAT_MAX_MS = 20000; // Must be shorter than WAITING_ROOM_HEARTBEAT_MIN_MS so a stalled request
// can never silently stall the whole loop - fetch() has no built-in
// timeout, so without this a single hung request (flaky network, a
// throttled background tab, a server that never answers) would kill the
// loop for good since its promise never settles and nothing ever gets to
// reschedule the next tick.

const WAITING_ROOM_HEARTBEAT_TIMEOUT_MS = 8000;

function randomWaitingRoomHeartbeatDelay() {
  return WAITING_ROOM_HEARTBEAT_MIN_MS + Math.random() * (WAITING_ROOM_HEARTBEAT_MAX_MS - WAITING_ROOM_HEARTBEAT_MIN_MS);
} // Keeps a visitor's waiting-room session alive while they stay on the event
// page without navigating (eg. filling out the checkout form), since only
// navigation requests otherwise refresh the session.


export function useWaitingRoomHeartbeat() {
  React.useEffect(() => {
    let timeoutId;
    let cancelled = false;
    let inFlight = false;

    async function heartbeat() {
      inFlight = true;

      try {
        if (Cookie.get(WAITING_ROOM_ACTIVE_COOKIE) === "1") {
          const controller = new AbortController();
          const abortTimer = window.setTimeout(() => controller.abort(), WAITING_ROOM_HEARTBEAT_TIMEOUT_MS);

          try {
            const res = await fetch(WAITING_ROOM_HEARTBEAT_PATH, {
              method: "HEAD",
              signal: controller.signal
            });

            if (!cancelled && res.status === 205) {
              window.location.reload();
              return;
            }
          } finally {
            window.clearTimeout(abortTimer);
          }
        }
      } catch (e) {
        if (e.name !== "AbortError") {
          Sentry.captureException(e);
        }
      } finally {
        inFlight = false;

        if (!cancelled) {
          timeoutId = window.setTimeout(heartbeat, randomWaitingRoomHeartbeatDelay());
        }
      }
    }

    function handleVisibilityChange() {
      // Background tabs can have their timers throttled/paused by the
      // browser, so check immediately instead of waiting for a stale timeout
      // once the tab is visible again. Skip if a heartbeat is already in
      // flight so we never race two overlapping chains over the shared
      // timeoutId.
      if (document.visibilityState === "visible" && !inFlight) {
        window.clearTimeout(timeoutId);
        heartbeat();
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);
    timeoutId = window.setTimeout(heartbeat, randomWaitingRoomHeartbeatDelay());
    return () => {
      cancelled = true;
      window.clearTimeout(timeoutId);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
}
export async function releaseSeatsioObjects() {
  try {
    // Tell seatsio to release selected seats
    const chart = window.seatsio?.charts[0];

    if (chart) {
      const selectedObjects = chart.selectedObjects;

      if (selectedObjects.length > 0) {
        await chart.deselectObjects(selectedObjects);
      }
    }
  } catch (e) {
    console.error(e);
  }
}

var _StyledInput3 = _styled("input").withConfig({
  displayName: "shared___StyledInput3",
  componentId: "sc-1kqbbso-7"
})(p => ({
  position: "absolute",
  opacity: 0,
  "&:checked + span": {
    backgroundColor: p._css5,
    border: p._css6
  },
  "&:hover + span": {
    border: p._css7
  }
}));

var _StyledSpan3 = _styled("span").withConfig({
  displayName: "shared___StyledSpan3",
  componentId: "sc-1kqbbso-8"
})({
  "&:first-of-type": {
    marginRight: "0.5rem",
    display: "inline-block",
    position: "relative",
    height: "18px",
    width: "18px",
    borderRadius: "3px",
    transform: "scale(1)",
    verticalAlign: "middle",
    backgroundColor: "white",
    border: "1.5px solid rgb(189, 189, 189)",
    transition: "background 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
  }
});

export function Checkbox({
  label,
  onChange,
  disabled = false,
  initialChecked = false,
  required = false,
  name,
  id,
  ref,
  style = {}
}) {
  return /*#__PURE__*/React.createElement("label", {
    style: {
      cursor: disabled ? "unset" : "pointer",
      color: disabled ? "rgb(157, 157, 157)" : "rgb(51, 51, 51)",
      display: "-webkit-inline-box",
      position: "relative",
      ...style
    }
  }, /*#__PURE__*/React.createElement(_StyledInput3, {
    ref: ref,
    name: name,
    id: id,
    type: "checkbox",
    disabled: disabled,
    defaultChecked: initialChecked,
    onChange: onChange,
    required: required,
    _css5: disabled ? "rgb(189, 189, 189)" : "rgb(50, 109, 233)",
    _css6: disabled ? "1.5px solid rgb(189, 189, 189)" : "1.5px solid rgb(50, 109, 233)",
    _css7: !initialChecked ? "1.5px solid rgb(157, 157, 157)" : "inherit"
  }), /*#__PURE__*/React.createElement(_StyledSpan3, null, /*#__PURE__*/React.createElement("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10",
    style: {
      position: "absolute",
      top: "2px",
      left: "2px",
      fill: "none",
      stroke: "rgb(255, 255, 255",
      strokeWidth: "1.5px",
      transition: "stroke-dashoffset 0.3s ease 0.1s",
      transform: "translate3d(0px, 0px, 0px)"
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "1.5 6 4.5 9 10.5 1"
  }))), label && /*#__PURE__*/React.createElement("span", {
    style: {
      display: "block",
      paddingTop: "1.5px"
    }
  }, label));
}

var _StyledDiv3 = _styled("div").withConfig({
  displayName: "shared___StyledDiv3",
  componentId: "sc-1kqbbso-9"
})({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  alignItems: "center",
  // Needed to fix Safari bug
  img: {
    margin: "0 5px 0 0"
  },
  "@media(max-width: 500px)": {
    img: {
      margin: "0 3px 0 0"
    },
    "img:last-child": {
      margin: 0
    }
  }
});

var _StyledImg = _styled("img").withConfig({
  displayName: "shared___StyledImg",
  componentId: "sc-1kqbbso-10"
})({
  width: 80
});

var _StyledImg2 = _styled("img").withConfig({
  displayName: "shared___StyledImg2",
  componentId: "sc-1kqbbso-11"
})({
  width: 45
});

var _StyledImg3 = _styled("img").withConfig({
  displayName: "shared___StyledImg3",
  componentId: "sc-1kqbbso-12"
})({
  width: 50
});

var _StyledImg4 = _styled("img").withConfig({
  displayName: "shared___StyledImg4",
  componentId: "sc-1kqbbso-13"
})({
  width: 40
});

var _StyledImg5 = _styled("img").withConfig({
  displayName: "shared___StyledImg5",
  componentId: "sc-1kqbbso-14"
})({
  width: 40
});

export function PaymentIcons({
  whitelabel,
  showMobilePay = false
}) {
  return /*#__PURE__*/React.createElement(_StyledDiv3, null, whitelabel.mobile_pay_active && showMobilePay && /*#__PURE__*/React.createElement(_StyledImg, {
    src: mobilePayIcon
  }), whitelabel.payment_provider === "QUICKPAY" && /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && /*#__PURE__*/React.createElement(_StyledImg2, {
    src: applePayIcon
  }), whitelabel.payment_provider === "QUICKPAY" && /*#__PURE__*/React.createElement(_StyledImg3, {
    src: dankortIcon
  }), /*#__PURE__*/React.createElement(_StyledImg4, {
    src: visaIcon
  }), /*#__PURE__*/React.createElement(_StyledImg5, {
    src: mastercardIcon
  }));
}